import React from "react";

const About = () => {
  return (
    <main className="bg-gradient-to-b from-slate-50 to-white text-gray-900">

      {/* ================= Section 1: Hero ================= */}
      <section aria-labelledby="about-heading" className="py-5 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 via-indigo-50/30 to-purple-50/50" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid gap-12 lg:gap-20 md:grid-cols-2 items-center">

          {/* Left Content */}
          <div className="lg:pr-12 py-5  motion-safe:animate-fade-up">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-2xl mb-8 backdrop-blur-sm border border-blue-200 max-w-max">
              <span className="text-xl" role="img" aria-label="Speech">💬</span>
              <span className="text-sm font-bold text-blue-700 uppercase tracking-wider">Our Mission</span>
            </div>
            <h1 id="about-heading" className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-tight bg-gradient-to-r from-gray-900 via-blue-900 to-indigo-900 bg-clip-text">
              Helping you speak English
              <span className="block mt-4 text-[#2467B1] bg-clip-text drop-shadow-lg">
                with confidence
              </span>
            </h1>

            <div className="mt-8 space-y-4 text-lg lg:text-xl text-gray-700 max-w-lg leading-relaxed">
              <p>Well Spoken is an online English learning platform designed for students and working professionals who want to communicate clearly, confidently, and naturally in real-life situations.</p>
              <p>Our live, interactive classes focus on practical speaking skills — from everyday conversations to professional communication.</p>
            </div>
          </div>

          {/* Right Visual - Enhanced Card */}
          <div className="group relative bg-white/80 backdrop-blur-xl rounded-3xl p-8 lg:p-12 border border-white/50 shadow-2xl hover:shadow-3xl hover:-translate-y-3 transition-all duration-500 lg:h-[420px] flex flex-col justify-center">
            <div className="absolute top-6 right-6 w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl -rotate-3 blur-sm opacity-20 group-hover:opacity-30 transition-opacity" />
            <h2 className="text-2xl lg:text-3xl font-black text-gray-900 mb-6 bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text">What we focus on</h2>
            <ul className="space-y-4 text-lg lg:text-xl text-gray-700">
              <li className="flex items-center gap-4 p-4 bg-white/50 rounded-xl backdrop-blur-sm border-l-4 border-blue-400 hover:bg-white hover:shadow-md transition-all duration-300">
                <span className="text-2xl" role="img" aria-label="Fluent">🗣️</span>
                Speaking fluently, not memorizing rules
              </li>
              <li className="flex items-center gap-4 p-4 bg-white/50 rounded-xl backdrop-blur-sm border-l-4 border-purple-400 hover:bg-white hover:shadow-md transition-all duration-300">
                <span className="text-2xl" role="img" aria-label="Real-world">🎭</span>
                Real-world conversations & role-plays
              </li>
              <li className="flex items-center gap-4 p-4 bg-white/50 rounded-xl backdrop-blur-sm border-l-4 border-emerald-400 hover:bg-white hover:shadow-md transition-all duration-300">
                <span className="text-2xl" role="img" aria-label="Feedback">📝</span>
                Personalized feedback from experts
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= Section 2: Teaching Approach ================= */}
      <section aria-labelledby="approach-heading" className="py-5 lg:py-10 bg-gradient-to-b from-blue-50 to-indigo-50 relative">
        <div className="absolute right-0 top-20 w-96 h-96 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full blur-3xl opacity-50 hidden lg:block" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <header className="text-center mb-20 lg:mb-24 motion-safe:animate-fade-up">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-3xl mb-8 backdrop-blur-sm border border-indigo-200 max-w-max mx-auto">
              <span className="text-3xl" role="img" aria-label="Method">🎯</span>
              <span className="text-sm font-bold text-indigo-700 uppercase tracking-widest">Teaching Approach</span>
            </div>
            <h2 id="approach-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 bg-gradient-to-r from-gray-900 to-indigo-900 bg-clip-text leading-tight">
              Our Teaching Approach
            </h2>
          </header>

          {/* <div className="grid gap-8 lg:gap-10 xl:gap-12 md:grid-cols-3">
            {[
              {
                title: "Live Interactive Classes",
                desc: "Small group sessions that encourage speaking, interaction, and confidence building.",
                color: "from-blue-500 to-indigo-500",
                icon: "🎙️"
              },
              {
                title: "Practical Learning",
                desc: "Lessons built around real-life situations like meetings, interviews, and daily conversations.",
                color: "from-purple-500 to-pink-500",
                icon: "💼"
              },
              {
                title: "Personal Feedback",
                desc: "Each learner receives structured feedback to improve pronunciation and clarity.",
                color: "from-emerald-500 to-teal-500",
                icon: "⭐"
              },
            ].map((item, index) => (
              <article
                key={index}
                className="group relative bg-gradient-to-br from-gray-100 to-gray-200 backdrop-blur-xl rounded-3xl p-8 lg:p-10 xl:p-12 border border-white/50 shadow-xl hover:shadow-3xl hover:-translate-y-4 hover:scale-[1.02] transition-all duration-700 overflow-hidden h-full"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-50/0 via-white/30 to-purple-50/0 group-hover:bg-gradient-to-r group-hover:from-blue-500/5 group-hover:to-indigo-500/5 transition-all duration-700" />
                <div className="relative">
                  <div className={`w-10 h-10 lg:w-20 lg:h-20 bg-gradient-to-br ${item.color} rounded-3xl flex items-center justify-center shadow-2xl group-hover:scale-110 group-hover:shadow-3xl transition-all duration-700 mb-6 mx-auto transform -rotate-6 group-hover:rotate-0`}>
                    <span className="text-2xl lg:text-3xl" role="img" aria-label={item.title}>{item.icon}</span>
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4 text-center group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-indigo-600 group-hover:bg-clip-text transition-all duration-500">
                    {item.title}
                  </h3>
                  <p className="text-lg lg:text-xl text-gray-700 leading-relaxed text-center px-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div> */}

          <div className="grid gap-10 lg:gap-14 md:grid-cols-2 items-stretch">

            {/* Group Session */}
            <article className="group bg-white/80 backdrop-blur-xl rounded-3xl overflow-hidden shadow-2xl hover:-translate-y-3 transition-all duration-500">
              <img
                src="/images/groupDiscussion.jpeg"
                alt="Small group English speaking session with learners interacting"
                className="w-full h-68 object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="p-8 lg:p-10">
                <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4">
                  Group Sessions
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Learn in small, interactive groups that encourage conversation,
                  peer learning, and confidence building. Group sessions help you
                  practice real conversations in a comfortable environment.
                </p>
              </div>
            </article>

            {/* Role Play */}
            <article className="group bg-white/80 backdrop-blur-xl rounded-3xl overflow-hidden shadow-2xl hover:-translate-y-3 transition-all duration-500">
              <img
                src="/images/rolePlay.jpeg"
                alt="English role-play practice for interviews and workplace communication"
                className="w-full h-100 object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="p-8 lg:p-10">
                <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-4">
                  Role-Play Practice
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Practice interview situations, workplace conversations, and
                  real-life scenarios through guided role-plays. This method helps
                  you overcome hesitation and speak confidently in real situations.
                </p>
              </div>
            </article>

          </div>

        </div>
      </section>

      {/* ================= Section 3: Why Choose Us ================= */}
      <section
        aria-labelledby="why-heading"
        className="relative py-10 lg:py-20 bg-gradient-to-b from-blue-50 to-indigo-50 overflow-hidden"
      >
        {/* Decorative background */}
        <div className="absolute left-0 bottom-24 w-[420px] h-[420px] bg-gradient-to-tr from-indigo-200/30 to-purple-200/30 rounded-full blur-3xl hidden xl:block" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          {/* Header */}
          <header className="text-center mb-16 lg:mb-24">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-emerald-100 to-blue-100 rounded-full border border-emerald-200 mb-6">
              <span className="text-2xl" aria-hidden>👑</span>
              <span className="text-xs sm:text-sm font-bold text-emerald-700 uppercase tracking-widest">
                Why Choose Us
              </span>
            </div>

            <h2
              id="why-heading"
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 leading-tight"
            >
              Why Choose{" "}
              <span className="bg-gradient-to-r from-blue-700 to-purple-700 bg-clip-text text-transparent">
                Well Spoken
              </span>
            </h2>
          </header>

          {/* Cards */}
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {[
              {
                text: "Experienced trainers",
                icon: "👨‍🏫",
                bg: "from-blue-500/10 to-blue-400/10",
                border: "border-blue-200/60",
                iconBg: "from-white to-blue-100",
                textColor: "text-blue-700",
              },
              {
                text: "Flexible schedules",
                icon: "⏰",
                bg: "from-emerald-500/10 to-emerald-400/10",
                border: "border-emerald-200/60",
                iconBg: "from-white to-emerald-100",
                textColor: "text-emerald-700",
              },
              {
                text: "Small class sizes",
                icon: "👥",
                bg: "from-purple-500/10 to-purple-400/10",
                border: "border-purple-200/60",
                iconBg: "from-white to-purple-100",
                textColor: "text-purple-700",
              },
              {
                text: "Affordable pricing",
                icon: "💰",
                bg: "from-orange-500/10 to-orange-400/10",
                border: "border-orange-200/60",
                iconBg: "from-white to-orange-100",
                textColor: "text-orange-700",
              },
            ].map((item, index) => (
              <article
                key={index}
                tabIndex={0}
                className={`
            group relative h-full
            rounded-3xl border ${item.border}
            bg-gradient-to-br ${item.bg}
            backdrop-blur-xl
            p-6 sm:p-8 xl:p-10
            flex flex-col items-center justify-center text-center
            shadow-lg hover:shadow-2xl
            transition-all duration-300
            hover:-translate-y-2
            focus:outline-none focus:ring-2 focus:ring-offset-2
          `}
              >
                {/* Icon wrapper */}
                <div
                  className={`
              w-16 h-16 sm:w-18 sm:h-18 lg:w-20 lg:h-20
              rounded-2xl bg-gradient-to-br ${item.iconBg}
              flex items-center justify-center
              shadow-xl
              mb-5
              transition-transform duration-300
              group-hover:scale-110
            `}
                >
                  <span className="text-2xl lg:text-3xl" aria-hidden>
                    {item.icon}
                  </span>
                </div>

                {/* Text */}
                <p className="text-base sm:text-lg lg:text-xl xl:text-2xl font-bold text-gray-900 leading-snug">
                  {item.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
      {/* ================= Section 4: Vision ================= */}
      <section aria-labelledby="vision-heading" className="py-5 lg:py-10 bg-gradient-to-b from-blue-50 to-indigo-50 relative">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-200/20 via-transparent to-purple-200/20" />
        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center motion-safe:animate-fade-up">
          <div className="inline-flex items-center gap-3 px-10 py-5 bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/50 mb-12 mx-auto max-w-max">
            <span className="text-3xl" role="img" aria-label="Vision">🌍</span>
            <span className="text-xl font-black text-gray-900 uppercase tracking-widest">Our Vision</span>
          </div>
          <h2 id="vision-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-transparent bg-gradient-to-r from-blue-900 via-indigo-900 to-purple-900 bg-clip-text mb-8 leading-tight drop-shadow-2xl">
            Empowering Global Communication
          </h2>
          <p className="text-lg lg:text-xl xl:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed backdrop-blur-sm">
            To empower learners across the world with strong communication skills that open doors to better education, careers, and confidence in everyday life.
          </p>
        </div>
      </section>
    </main>
  );
};

export default About;
